let nonce: string | undefined;

export function getCspNonce(): string | undefined {
  if (nonce !== undefined) return nonce;

  if (typeof document !== 'undefined') {
    nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? undefined;
  }

  return nonce;
}
